import client from "./axiosConfig";

export const createClient = (data) => {
    const config = {
        url: `/users/clients/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const getClient = (params) => {
    const config = {
        url: `/users/clients/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const getClientById = (id) => {
    const config = {
        url: `/users/clients/${id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const updateClient = (id, data) => {
    const config = {
        url: `/users/clients/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const deleteClient = (id) => {
    const config = {
        url: `/users/clients/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}